import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "app-section" }

import SectionSidebar from '@/components/SectionSidebar.vue'
import type { SidebarMenuItem } from '@/components/SectionSidebar.vue'
import SouscriptionWidget from '@/components/SouscriptionWidget.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'CarteLayout',
  setup(__props) {

const menuItems: SidebarMenuItem[] = [
  {
    to: '/front/ma-carte',
    icon: '/public/icons/icon-carte.svg',
    label: 'Ma carte',
    exact: true,
    initialSidebarOpen: true
  },
  {
    to: '/front/ma-carte/transactions',
    icon: '/public/icons/icon-transaction.svg',
    label: 'Transactions',
    initialSidebarOpen: true
  },
  {
    to: '/front/ma-carte/repartition',
    icon: '/public/icons/icon-souscription.svg',
    label: 'Répartition',
    initialSidebarOpen: true
  },
  {
    to: '/front/ma-carte/parametres',
    icon: '/public/icons/icon-verrouillage.svg',
    label: 'Paramètres',
    initialSidebarOpen: true
  }
]

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(SectionSidebar, { "menu-items": menuItems }, {
      widget: _withCtx(() => [
        _createVNode(SouscriptionWidget)
      ]),
      _: 1
    }),
    _createElementVNode("section", _hoisted_1, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-space-50" }, null, -1)),
      _createVNode(_component_router_view)
    ])
  ], 64))
}
}

})